export const DOB_FORMAT = "MM/DD/YYYY";
export const SESSION_DATE_FORMAT = "dddd, MMM. D, YYYY";
export const NATIVE_DATE_INPUT_FORMAT = "YYYY-MM-DD";
